"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayHelper = void 0;
class ArrayHelper {
    static intersect(...arrays) {
        if (arrays.length === 0) {
            return [];
        }
        let result = arrays[0];
        for (let i = 1; i < arrays.length; i++) {
            result = this.intersect(result, arrays[i]);
        }
        return result;
    }
    static contains(array, obj) {
        return array.indexOf(obj) >= 0;
    }
    static any(array, selector) {
        return !!array.find(selector);
    }
    static remove(array, obj) {
        const index = array.indexOf(obj);
        if (index >= 0) {
            array.splice(index, 1);
        }
    }
    static removeAll(source, array) {
        if (array) {
            for (let i = 0; i < array.length; i++) {
                this.remove(source, array[i]);
            }
        }
    }
    static match(array, regEx) {
        return array.filter((i) => !!i && i.toString().match(regEx));
    }
    static replace(array, oldItem, newItem) {
        const index = array.indexOf(oldItem);
        if (index >= 0) {
            array[index] = newItem;
        }
    }
    static unionAll(array, selector) {
        const arrays = array.map((i) => selector(i));
        const result = [];
        for (let i = 0; i < arrays.length; i++) {
            result.push(...arrays[i]);
        }
        return result;
    }
}
exports.ArrayHelper = ArrayHelper;
//# sourceMappingURL=array-helper.js.map